import React from "react";

interface HeroProps {
  heroRef: React.RefObject<HTMLElement | null>;
  companyName: string;
}

const Hero: React.FC<HeroProps> = ({ heroRef, companyName }) => {
  return (
    <section ref={heroRef} className="w-full min-h-screen flex flex-col items-center justify-center px-6 lg:px-12 pt-32 pb-20 relative overflow-hidden">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-b from-blue-50/50 via-white to-white" />
        <div className="absolute top-[10%] left-[5%] w-72 h-72 bg-primary/10 rounded-full blur-[100px] animate-float" />
        <div className="absolute bottom-[20%] right-[5%] w-[500px] h-[500px] bg-secondary/10 rounded-full blur-[120px] animate-float" style={{ animationDelay: '-3s' }} />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-grid-pattern opacity-20" />
      </div>

      <div className="max-w-7xl mx-auto relative z-10 flex flex-col items-center text-center">
        <div className="flex flex-col items-center gap-4 mb-10 hero-badge">
          {/* Dynamic Trust Badge */}
          <div className="flex items-center gap-3 px-6 py-2.5 bg-white/80 backdrop-blur-md border border-secondary/20 shadow-xl rounded-full">
            <div className="w-2.5 h-2.5 rounded-full bg-secondary animate-pulse shadow-[0_0_10px_rgba(212,165,74,0.8)]" />
            <span className="text-[10px] md:text-xs font-black tracking-[0.2em] text-text-secondary uppercase">
               Authorized: {companyName} is a Registered NBFC
            </span>
          </div>
        </div>

        <h1 className="hero-headline text-5xl sm:text-6xl md:text-7xl lg:text-9xl font-black tracking-tighter mb-8 text-text-primary leading-[1] md:leading-[0.9]">
          Precision Capital. <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary via-secondary to-primary bg-[length:200%_auto] animate-shimmer text-glow">Unstoppable Growth.</span>
        </h1>

        <p className="hero-subtext text-lg md:text-2xl text-text-secondary max-w-3xl leading-relaxed font-medium mb-12 opacity-90">
          Step into the next era of financial empowerment. At {companyName}, we merge institutional-tier security with high-velocity lending to deliver the capital you need, with radical transparency.
        </p>

        <div className="cta-terminal flex flex-col sm:flex-row gap-6 items-center justify-center w-full sm:w-auto">
          <a
            href="/#services"
            className="w-full sm:w-auto px-12 py-5 bg-primary text-white font-black text-lg rounded-2xl transition-all duration-500 hover:scale-105 hover:shadow-[0_20px_50px_-10px_rgba(var(--primary-rgb),0.5)] shadow-2xl relative overflow-hidden group"
          >
            <span className="relative z-10">Apply For Loan</span>
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000" />
          </a>
          <a
            href="/loan-calculator"
            className="w-full sm:w-auto px-12 py-5 glass-morphism text-text-primary font-black text-lg rounded-2xl hover:bg-white transition-all duration-500 shadow-xl hover:shadow-2xl hover:-translate-y-1 flex items-center justify-center gap-2"
          >
            Calculate EMI
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
